__turbopack_context__.v({
  "body": "SearchDemo-module__rJjY5W__body",
  "component": "SearchDemo-module__rJjY5W__component",
  "credit": "SearchDemo-module__rJjY5W__credit",
  "descriptionText": "SearchDemo-module__rJjY5W__descriptionText",
  "film": "SearchDemo-module__rJjY5W__film",
  "filmBody": "SearchDemo-module__rJjY5W__filmBody",
  "filtersColumn": "SearchDemo-module__rJjY5W__filtersColumn",
  "header": "SearchDemo-module__rJjY5W__header",
  "logo": "SearchDemo-module__rJjY5W__logo",
  "mainContent": "SearchDemo-module__rJjY5W__mainContent",
  "meta": "SearchDemo-module__rJjY5W__meta",
  "metadataRow": "SearchDemo-module__rJjY5W__metadataRow",
  "popoverContent": "SearchDemo-module__rJjY5W__popoverContent",
  "poster": "SearchDemo-module__rJjY5W__poster",
  "resultTitle": "SearchDemo-module__rJjY5W__resultTitle",
  "scrollFilters": "SearchDemo-module__rJjY5W__scrollFilters",
  "searchInput": "SearchDemo-module__rJjY5W__searchInput",
  "secondaryText": "SearchDemo-module__rJjY5W__secondaryText",
  "voteDisplay": "SearchDemo-module__rJjY5W__voteDisplay",
  "wrapper": "SearchDemo-module__rJjY5W__wrapper",
});
